function fnPostsGrid(i, oContent) {

    //console.log(siteURL);
    let baseURL = siteURL + '/wp-json/wp/v2/',
        ax = axios.create({
            baseURL: baseURL
        });

    const postsGripApp = new Vue({
        el: '#posts-grid',
        data: {
            loading: false,
            activeCat: 'all',
            isTogglerActive: false,
            categories: [],
            posts: [],
            filteredPosts: [],
            paginatePosts: [],
            page: 1,
            perPage: 36,
            pages: [],
        },
        methods: {
            scrollSpeed(index) {
                let speed = '0';
                if ((index % 3) == 1) {
                    speed = '-1';
                } else if ((index % 3) == 2) {
                    speed = '0';
                } else {
                    speed = '1';
                }
                return speed;
            },
            catMobileToggler() {
                this.isTogglerActive = !this.isTogglerActive;
            },
            getCategories() {
                let _this = this;
                ax.get("case_study_category").then(function (response) {
                    _this.categories = response.data;
                });
            },
            getPosts() {
                let _this = this;
                ax.get("case_study?per_page=100&sticky=0&status=publish").then(function (response) {
                    _this.posts = response.data;
                });
            },
            filterBy(filterSelected) {
                this.activeCat = filterSelected ? filterSelected : 'all';
                this.page = 1;
                this.filteredPosts = this.posts.filter(function (query) {
                    console.log(query.term_object);
                    return query.term_object.slug === filterSelected;
                });
                this.setPages();
                //setTimeout(() => locoScroll.update(), 500);
                return false;
            },
            setPages() {
                if (this.filteredPosts.length || this.activeCat !== 'all') {
                    this.paginatePosts = this.filteredPosts;
                } else {
                    this.paginatePosts = this.posts;
                }
                //console.log(this.page);
                let numberOfPages = Math.ceil(this.paginatePosts.length / this.perPage);
                this.pages = [];
                for (let index = 1; index <= numberOfPages; index++) {
                    this.pages.push(index);
                }
            },
            paginate(posts) {
                let page = this.page;
                let perPage = this.perPage;
                let from = (page * perPage) - perPage;
                let to = (page * perPage);
                //console.log(posts);
                return posts.slice(from, to);

            }
        },
        mounted() {
            this.getCategories();
            this.getPosts();
            this.$nextTick(function () {
                this.loading = true;
            })
        },
        watch: {
            posts() {
                this.setPages();
            }
        },
        computed: {
            displayedPosts() {
                //setTimeout(() => locoScroll.update(), 500);
                return this.paginate(this.paginatePosts);
            },
        },

    })

}